import {Pill} from '@wandb/components';
import React, {useCallback} from 'react';
import {type Editor} from 'slate';
import {Editable, type RenderElementProps, Slate} from 'slate-react';

const INITIAL_VALUE = [{type: 'paragraph', children: [{text: ''}]}];

export const WBAgentEditor = ({
  editor,
  hasProjectContext,
  onChange,
  onKeyDown,
}: {
  editor: Editor;
  hasProjectContext: boolean;
  onChange: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
}) => {
  const renderElement = useCallback(
    (props: RenderElementProps) => <Element {...props} />,
    []
  );

  return (
    <Slate editor={editor} initialValue={INITIAL_VALUE} onChange={onChange}>
      <Editable
        renderElement={renderElement}
        placeholder="Ask the W&B agent"
        spellCheck
        autoFocus
        onKeyDown={onKeyDown}
        className="outline-none"
        readOnly={!hasProjectContext}
      />
    </Slate>
  );
};

const Element = ({attributes, children, element}: RenderElementProps) => {
  if (element.type === 'run-mention') {
    return (
      <span {...attributes} contentEditable={false} className="align-middle">
        <Pill icon="running-repeat" textValue={element.displayName} />
        <span style={{display: 'none'}}>{children}</span>
      </span>
    );
  }
  return <div {...attributes}>{children}</div>;
};
